const mock = {
    "results": {
      "score": 3,
      "maxScore": 10
    },
    "submissionDate": null,
    "passed": null,
    "sealed": false,
    "questions": null,
    "answers": null,
    "startsAt": "2024-09-30T21:10:37.1034967+00:00",
    "endsAt": "2024-10-02T21:10:37.1034974+00:00"
  };

export default mock;
